import './BuyerStateBreakdown.scss';
import Component from './BuyerStateBreakdown.js';
export default Component;
